import { useEffect, useState } from "react";
import "../styles/singlepost.scss";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import MenuTab from "../components/menu_tab";
import Banner from "../components/banner";

export default function SinglePost(props) {
  const { state } = useLocation();
  const navigate = useNavigate();
  const id = window.location.pathname.split("/")[3];

  const [toggleMenu, setToggleMenu] = useState(false);
  const [data, setData] = useState(null);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  // Document state
  const [activeDoc, setActiveDoc] = useState(null);

  useEffect(() => {
    fetch(`/api/news/${id}`)
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error("");
      })
      .then((data) => {
        setData(data);
      })
      .catch(() => {});
  }, [id]);

  // Image rotation
  useEffect(() => {
    const images = data?.Images;

    if (!images || images.length <= 1) return;

    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) =>
          (prevIndex + 1) % images.length
        );
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [data, isPaused]);

  const handlePause = () => setIsPaused(true);
  const handleResume = () => setIsPaused(false);

  // Helpers
  const isPdf = (file) =>
    typeof file === "string" && file.toLowerCase().endsWith(".pdf");

  const getFileName = (path) =>
    typeof path === "string" ? path.split("/").pop() : "";

  return (
    <div className="body">
      <Banner />
      <Header toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
      {toggleMenu && (
        <MenuTab toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
      )}

      <div className="image2">
        <div id="newconnection">
          <p>News & Events</p>
        </div>
      </div>

      {data && (
        <div className="single-post">
          <div className="post-container">
            {/* Title */}
            <h1 className="post-title">{data.Title}</h1>

            {/* Date */}
            <p className="post-date">{data.Date}</p>

            {/* Image Slideshow */}
            {data.Images && data.Images.length > 0 && (
              <div className="post-image">
                <img
                  src={`/api/${data.Images[currentImageIndex]}`}
                  alt=""
                  onMouseDown={handlePause}
                  onMouseUp={handleResume}
                  onMouseLeave={handleResume}
                  onTouchStart={handlePause}
                  onTouchEnd={handleResume}
                />
              </div>
            )}

            {/* Content */}
            {/* Content */}
            <div className="post-details">
              {data.Description
                ?.split(/\n\s*\n/)
                .filter(paragraph => paragraph.trim() !== "")
                .map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
            </div>

            {/* Documents Section */}
            {data.Documents && data.Documents.length > 0 && (
                <section className="documents-section">
                    <div className="documents-header">
                    <h3>Attached Documents</h3>
                    <p>View or download the files associated with this post</p>
                    </div>

                    <ul className="documents-list">
                    {data.Documents.map((doc, index) => (
                        <li key={index} className="document-item">
                        {/* File info */}
                        <div className="file-info">
                            <div className="file-icon">📄</div>
                            <span className="file-name">{getFileName(doc)}</span>
                        </div>

                        {/* Actions */}
                        <div className="file-actions">
                            {isPdf(doc) && (
                            <button
                                onClick={() => setActiveDoc(doc)}
                                className="btn-view"
                            >
                                View
                            </button>
                            )}
                            <a
                            href={`/api/${doc}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-open"
                            >
                            Open
                            </a>
                        </div>
                        </li>
                    ))}
                    </ul>
                </section>
            )}


            {/* Inline PDF Viewer */}
            {activeDoc && isPdf(activeDoc) && (
              <div className="pdf-viewer">
                <div className="pdf-viewer-header">
                  <span>{getFileName(activeDoc)}</span>
                  <button className="close-btn" onClick={() => setActiveDoc(null)}>✕ Close</button>
                </div>

                <iframe
                  src={`/api/${activeDoc}`}
                  title="Document Preview"
                  width="100%"
                  height="600px"
                />
              </div>
            )}
          </div>

          {/* Back Button */}
          <div className="back-button-container">
            <button className="back-button" onClick={() => navigate(-1)}>
              &larr; Back
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
